export default "__VITE_ASSET__RzZyzRiy__"